export default [
  {
    path: "/call-center",
    name: "call-center",
    component: () => import("@/views/callSettings/View.vue"),
    meta: {
      pageTitle: "breadcrumb.callCenter",
      navActiveLink: "call-center",
      resource: "call-center",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.callCenter",
          active: false,
        },
      ],
    },
  },
];
